import PropTypes, { number, oneOf, oneOfType, string } from 'prop-types';
import React from 'react';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import LinesEllipsisLoose from 'react-lines-ellipsis/lib/loose';
import styled from 'styled-components';

import { get, isEmpty, responsiveProptypes, sanitizeMarkup, themeGet } from 'ravenjs/utils';

const DescriptionStyled = styled(HTMLEllipsis)`
    color: ${({ color }) => color || themeGet('palette.common.black')};
    margin: ${({ margin }) => margin};
`;

const TextContainer = styled(LinesEllipsisLoose)`
    overflow: hidden;
`;

class Ellipsis extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ellipsisContent: '',
            renderContent: this.renderContent,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.content !== this.props.content) {
            this.updateContent(this.props.content);
        }
    }

    updateContent = content => {
        this.setState({ ellipsisContent: content });
    };

    renderContent = () => {
        const { color, content, enableResize, maxLine, onlyText, size, ...rest } = this.props;
        const ellipsisContent = get(this.state, 'ellipsisContent', content);

        let description = {};
        let finalContent = '';

        if (!onlyText) {
            finalContent = !isEmpty(ellipsisContent)
                ? typeof ellipsisContent === 'string' && ellipsisContent.split('\n')
                : [];

            description = finalContent[0]
                ? sanitizeMarkup(finalContent[0], {
                      ADD_ATTR: ['target'],
                  })
                : {};
        }

        return !onlyText ? (
            <DescriptionStyled
                key={size}
                color={color}
                unsafeHTML={description.__html}
                maxLine={maxLine}
                ellipsis="..."
                basedOn="letters"
                {...rest}
            />
        ) : (
            <TextContainer text={ellipsisContent} maxLine={maxLine} color={color} />
        );
    };

    render() {
        return this.renderContent();
    }
}

Ellipsis.propTypes = {
    color: PropTypes.string,
    content: PropTypes.string,
    enableResize: PropTypes.bool,
    maxLine: PropTypes.number,
    onlyText: PropTypes.bool,
    size: responsiveProptypes(oneOfType([oneOf(['auto', '*', false]), number, string])),
};

Ellipsis.defaultProps = {
    color: null,
    content: '',
    enableResize: true,
    maxLine: 3,
    onlyText: false,
    size: '*',
};

export default Ellipsis;
